<section class="relative grow lg:bg-white">
    <rwidget-alert></rwidget-alert>
    <div class="lg:py-8">
        <ridango-page-content-wrapper>
            <section class="grid lg:grid-cols-[16rem_1fr] lg:gap-8">
                <aside class="hidden lg:block">
                    <h1 class="text-[2.75rem] font-bold leading-[3rem]">{{ 'ADD_MONEY' | translate }}</h1>
                    <!-- For now leave this out, it's in design but not implemented right now -->
                    <!--   <div class="mt-16 border-t border-solid border-grey-white_smoke">
                    <button
                        class="flex items-center gap-4 py-5 text-base font-bold normal-case leading-4 text-primary dark:text-contrast-yellow"
                        (click)="handleBackClicked()">
                        <ion-icon class="text-xl" name="arrow-back-outline"></ion-icon
                        >{{ 'LOCAL_BTN_BACK' | translate }}
                    </button>
                </div> -->
                    <div class="mt-3 border-t border-solid border-grey-white_smoke dark:border-contrast-yellow">
                        <nav class="mt-8">
                            <ul class="grid gap-4">
                                <li
                                    class="flex gap-6 before:block before:h-full before:w-2 before:rounded before:content-['']"
                                    *ngFor="let step of steps; let i = index"
                                    [ngClass]="
                                        step.name !== activeStep
                                            ? 'text-old_silver before:bg-grey-white_smoke dark:text-contrast-yellow dark:opacity-50 dark:before:bg-contrast-yellow dark:before:opacity-30'
                                            : 'before:bg-old_silver dark:text-contrast-yellow dark:before:bg-contrast-yellow'
                                    ">
                                    {{ step.title | translate }}
                                </li>
                            </ul>
                        </nav>
                    </div>
                </aside>

                <section class="grid grid-cols-[4rem_1fr_4rem] bg-white py-2.5 lg:hidden">
                    <div>
                        <ion-button
                            *ngIf="!env.PURCHASE_FLOW?.HIDE_WALLET_LOADING_BACK_BUTTON"
                            (click)="handleBackClicked()"
                            color="secondary"
                            fill="clear">
                            <ion-icon class="text-2xl" name="arrow-back-outline"></ion-icon>
                        </ion-button>
                        <div class="invisible" *ngIf="env.PURCHASE_FLOW?.HIDE_WALLET_LOADING_BACK_BUTTON"></div>
                    </div>

                    <h1 class="flex items-center justify-center text-base font-bold leading-5">
                        {{ 'ADD_MONEY' | translate }}
                    </h1>
                </section>

                <section class="flex flex-col justify-between">
                    <div [ngSwitch]="activeStep">
                        <ng-container *ngSwitchCase="'wallet'">
                            <gl-wallet-loading-page-v2-choose-a-ticket
                                (backClicked)="handleBackClicked()"
                                (nextClicked)="handleNextClicked()"></gl-wallet-loading-page-v2-choose-a-ticket>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <gl-wallet-loading-page-v2-choose-a-ticket
                                (backClicked)="handleBackClicked()"
                                (nextClicked)="handleNextClicked()"></gl-wallet-loading-page-v2-choose-a-ticket>
                        </ng-container>
                    </div>

                    <div
                        class="mt-4 w-full bg-white p-4 [box-shadow:0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_0px_4px_-1px_rgba(0,0,0,0.06)] lg:hidden">
                        <ion-button
                            class="tallinn-light:text-white w-full"
                            [disabled]="false"
                            (click)="handleNextClicked()"
                            size="large">
                            <ion-label
                                class="tartu-light:text-white gl-light:text-white vl-app-light:text-black whitespace-normal text-base font-bold normal-case dark:text-contrast-black">
                                {{ 'NEXT_BUTTON' | translate }}
                            </ion-label>
                            <ion-icon
                                class="tartu-light:text-white vl-app-light:text-black dark:filter-black"
                                name="arrow-forward-outline"
                                slot="end"></ion-icon>
                        </ion-button>

                        <nav class="mt-4">
                            <ul class="flex w-full justify-center gap-4">
                                <li
                                    class="flex gap-6 before:block before:h-2 before:w-12 before:rounded before:content-['']"
                                    *ngFor="let step of steps; let i = index"
                                    [ngClass]="
                                        step.name !== activeStep
                                            ? 'text-old_silver before:bg-grey-white_smoke dark:text-contrast-yellow dark:opacity-50 dark:before:bg-contrast-yellow dark:before:opacity-30'
                                            : 'before:bg-old_silver dark:text-contrast-yellow dark:before:bg-contrast-yellow'
                                    "></li>
                            </ul>
                        </nav>
                    </div>
                </section>
            </section>
        </ridango-page-content-wrapper>
    </div>
</section>
